// VenderAuto.jsx

import React, { useState } from 'react';
import {
  Calculator,
  MessageCircle,
  DollarSign,
  Search,
  HandHeart,
  CheckCircle,
  Eye,
  FileText,
  Clock,
  Zap,
  TrendingUp,
  Shield,
  Star,
  Users
} from 'lucide-react';
import Navbar from '../Navbar/Navbar';
import './VenderAutoComponent.css';

const VenderAuto = () => {
  const [selectedOption, setSelectedOption] = useState('directa');

  // Función para redirigir al formulario de tasación o enviar a WhatsApp
  const handleTasacionClick = () => {
    const phoneNumber = "5491134567890"; // Reemplazar con el número real
    const message = "¡Hola! Estoy listo para coordinar la entrega de mi moto. ¿Podemos proceder?"; // TEXTO MODIFICADO
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <div className="vender-auto-page">
      {/* Navbar agregado aquí */}
      <Navbar />

      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1>LA EMOCIÓN DE RECIBIR TU NUEVA MOTO</h1> {/* TEXTO MODIFICADO */}
              <p className="subtitle">Tu sueño en dos ruedas. <br /> Historias de entregas exitosas.</p> {/* TEXTO MODIFICADO */}
              <p className="description">
                Con más de 10 años de experiencia, te ofrecemos la mejor experiencia de compra y entrega de tu moto,
                de forma rápida, segura y con la mayor alegría.
              </p>

              <div className="cta-buttons">
                <button className="btn-primary" onClick={handleTasacionClick}>
                  <Calculator className="btn-icon" />
                  Coordinar la Entrega {/* TEXTO MODIFICADO */}
                </button>
              </div>

              <div className="trust-indicators">
                <div className="indicator">
                  <Star className="indicator-icon" />
                  <span>+500 motos entregadas</span> {/* TEXTO MODIFICADO */}
                </div>
                <div className="indicator">
                  <Shield className="indicator-icon" />
                  <span>Proceso de compra seguro</span> {/* TEXTO MODIFICADO */}
                </div>
                <div className="indicator">
                  <Users className="indicator-icon" />
                  <span>Clientes felices</span> {/* TEXTO MODIFICADO */}
                </div>
              </div>
            </div>

            <div className="hero-image">
              <div className="image-placeholder">
                <img
                  src="https://images.unsplash.com/photo-1558981403-ec52798a835a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" // IMAGEN CAMBIADA A UNA DE MOTO (ejemplo de URL, no funcional)
                  alt="Cliente feliz recibiendo su moto"
                  className="hero-img"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Opciones de Venta -> Ahora son Beneficios de la Entrega */}
      <section className="options-section">
        <div className="container">
          <br />
          <br />
          <h2 className="section-title">DETALLES QUE HACEN LA DIFERENCIA</h2> {/* TEXTO MODIFICADO */}
          <br />
          <br />
          <div className="options-grid">
            <div
              className={`option-card ${selectedOption === 'directa' ? 'active' : ''}`}
              onClick={() => setSelectedOption('directa')}
            >
              <div className="option-icon">
                <Zap className="icon" />
              </div>
              <h3>Entrega Express</h3> {/* TEXTO MODIFICADO */}
              <p className="option-description">
                Máxima velocidad para que empieces a rodar tu moto cuanto antes.
              </p>
              <ul className="benefits-list">
                <li><CheckCircle className="check-icon" /> Preparación inmediata</li> {/* TEXTO MODIFICADO */}
                <li><CheckCircle className="check-icon" /> Documentación finalizada</li> {/* TEXTO MODIFICADO */}
                <li><CheckCircle className="check-icon" /> Cita de retiro prioritaria</li> {/* TEXTO MODIFICADO */}
                <li><CheckCircle className="check-icon" /> Tu moto en la calle sin demoras</li> {/* TEXTO MODIFICADO */}
              </ul>
              <div className="option-badge">Rápida Satisfacción</div> {/* TEXTO MODIFICADO */}
            </div>

            <div
              className={`option-card ${selectedOption === 'consignacion' ? 'active' : ''}`}
              onClick={() => setSelectedOption('consignacion')}
            >
              <div className="option-icon">
                <TrendingUp className="icon" />
              </div>
              <h3>Experiencia Premium</h3> {/* TEXTO MODIFICADO */}
              <p className="option-description">
                Cuidado y atención en el proceso de entrega para una experiencia memorable.
              </p>
              <ul className="benefits-list">
                <li><CheckCircle className="check-icon" /> Instrucción de manejo detallada</li> {/* TEXTO MODIFICADO */}
                <li><CheckCircle className="check-icon" /> Sesión de fotos de entrega</li> {/* TEXTO MODIFICADO */}
                <li><CheckCircle className="check-icon" /> Kit de bienvenida de regalo</li> {/* TEXTO MODIFICADO */}
                <li><CheckCircle className="check-icon" /> Soporte post-venta garantizado</li> {/* TEXTO MODIFICADO */}
              </ul>
              <div className="option-badge">Momentos Memorables</div> {/* TEXTO MODIFICADO */}
            </div>
          </div>
        </div>
      </section>

      {/* Proceso Paso a Paso -> Ahora es "El Proceso de Entrega" */}
      <section className="process-section">
        <div className="container">
          <h2 className="section-title">EL DÍA DE LA ENTREGA: TU GRAN MOMENTO</h2> {/* TEXTO MODIFICADO */}
          <p className="section-subtitle">Tu moto lista en 3 pasos</p> {/* TEXTO MODIFICADO */}
          <div className="process-steps">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-icon">
                <Calculator className="icon" />
              </div>
              <h3>Confirmación</h3> {/* TEXTO MODIFICADO */}
              <p>Verificamos que todos los trámites de compra y patentamiento estén finalizados correctamente.</p> {/* TEXTO MODIFICADO */}
              <div className="step-details">
                <span className="detail-item">• Revisión de documentación</span> {/* TEXTO MODIFICADO */}
                <span className="detail-item">• Pago total verificado</span> {/* TEXTO MODIFICADO */}
                <span className="detail-item">• Confirmación de cita</span> {/* TEXTO MODIFICADO */}
              </div>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-icon">
                <Eye className="icon" />
              </div>
              <h3>Instrucción y Control</h3> {/* TEXTO MODIFICADO */}
              <p>Te mostramos cada función de tu nueva moto y realizamos una inspección final juntos.</p> {/* TEXTO MODIFICADO */}
              <div className="step-details">
                <span className="detail-item">• Capacitación personalizada</span> {/* TEXTO MODIFICADO */}
                <span className="detail-item">• Último control de calidad</span> {/* TEXTO MODIFICADO */}
                <span className="detail-item">• Asesoramiento de accesorios</span> {/* TEXTO MODIFICADO */}
              </div>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-icon">
                <HandHeart className="icon" />
              </div>
              <h3>Recibí la Llave</h3> {/* TEXTO MODIFICADO */}
              <p>¡Felicidades! Es momento de llevarte tu moto y empezar a disfrutar de la carretera.</p> {/* TEXTO MODIFICADO */}
              <div className="step-details">
                <span className="detail-item">• Llaves en mano y lista</span> {/* TEXTO MODIFICADO */}
                <span className="detail-item">• Regalos de bienvenida</span> {/* TEXTO MODIFICADO */}
                <span className="detail-item">• Foto con tu nueva moto</span> {/* TEXTO MODIFICADO */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="final-cta">
        <div className="container">
          <div className="cta-content">
            <h2>¿LISTO PARA EXPERIMENTAR ESTA ENTREGA?</h2> {/* TEXTO MODIFICADO */}
            <h3>¡Sé parte de las historias de clientes felices que ya están rodando!</h3> {/* TEXTO MODIFICADO */}
            <p>Si ya compraste, contactanos para coordinar el retiro de tu moto. Si estás por comprar, te garantizamos:</p> {/* TEXTO MODIFICADO */}
            <ul>
              <li>Una moto impecable, 100% revisada.</li> {/* TEXTO MODIFICADO */}
              <li>Documentación lista y transparente.</li> {/* TEXTO MODIFICADO */}
              <li>Un equipo que celebra tu nuevo viaje.</li> {/* TEXTO MODIFICADO */}
            </ul>
            <div className="final-buttons">
              <button className="btn-primary large" onClick={handleTasacionClick}>
                <Calculator className="btn-icon" />
                ¡Quiero mi Entrega Exitosa! {/* TEXTO MODIFICADO */}
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VenderAuto;